import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import {computed, observable} from "mobx";
import {IGooglePlace} from "../../../../../../shared/src/model/ICoworkGeoLocation";
import FirebaseFunctionsService from "src/services/firebase/functions/FirebaseFunctionsService";
import { BrokersState } from "../BrokersState";


export class BrokersStore extends ApiCallObservable {
    @observable public files: any = {
        coveragePdfFile: ''
    };
    @observable public formInput = {
        'location' : '',
        'fullName' : '',
        'workEmail' : '',
        'brokerPhoneNumber' : '',
        'clientName' : '',
        'clientEmail' : '',
        'brokerClientDeposit' : ''
    };
    @observable public navigationController = {};
    @observable public isEmailValid: boolean = true;
    @observable public emailErrorMessage:  string = '';
    @observable private _location: IGooglePlace | string = '';
    @observable private _currentScreen: BrokersState = BrokersState.welcome;
    @observable private _isFormFinish: boolean = false;

    public setInputValue = (formPage: string, propertyName: string, value: any) =>  {
        this.formInput[formPage][propertyName] = value;
    };

    get currentScreen() {
        return this._currentScreen;
    };

    @computed
    get getEmailErrorMessage(){
        return this.emailErrorMessage;
    };

    get location() {
        return this._location;
    };

    get allowFinishForm() {
        return this._isFormFinish;
    };

    public initState = () => {
        this.formInput = {
            'location' : '',
            'fullName' : '',
            'workEmail' : '',
            'brokerPhoneNumber' : '',
            'clientName' : '',
            'clientEmail' : '',
            'brokerClientDeposit' : ''
        }
        this._location = ``
    }

    public updateFinishForm = (value: boolean) => {
        this._isFormFinish = value;
    };

    public updateScreen = (screen: BrokersState) => {
        this._currentScreen = screen;
    };

    public updateLocation = (selectedCowork?: IGooglePlace | string) => {
        this._location = selectedCowork? selectedCowork : '';
        this.formInput["location"] = JSON.stringify(this._location);
    };

    public async submit() {
        try {
            this.setSending();
            const request = {
                source : "Broker",
                coworkLocation : this.formInput["location"],
                fullName : this.formInput["fullName"],
                workEmail : this.formInput["workEmail"],
                phoneNumber : this.formInput["brokerPhoneNumber"],
                clientName : this.formInput["clientName"],
                clientEmail : this.formInput["clientEmail"],
                deposit : this.formInput["brokerClientDeposit"],
            }
            
            const response = await FirebaseFunctionsService.brokerRequest(request);
            if (response.ok && response.data) {
                this.setSuccessfulResponse(response.data);
                this.updateScreen(BrokersState.finish);
            } else {
                console.log(`Server returned error!`);
                this.updateScreen(BrokersState.finish);
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
            this.updateScreen(BrokersState.finish);
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/BrokersStore.ts